













import { Component, Vue } from "vue-property-decorator";
import EntrySearch from "@/components/VEntrySearch.vue";
// import TopbarDropdown from "@/components/TopbarDropdown.vue";
import { currentUserStore } from "@/store/typed";

@Component({ components: { EntrySearch } })
export default class TheTopbar extends Vue {
  get currentUser() {
    return currentUserStore.currentUser;
  }
}
